<app-container
	class="mt-2 p-2 rounded-xl flex"
	*ngIf="lenderForms?.length"
	[collapsable]="true"
	[collapsed]="false"
>
	<div header class="flex flex-1 w-full pr-2">
		<span class="font-bold">{{ title }}</span>
	</div>
	<ng-container *ngIf="financialInstitution; else noFinancialInstitution">
		<app-anchor
			*ngIf="lenderWebsiteLink"
			size="small"
			[icon]="ICON.ARROW_UP_RIGHT"
			class="text-green underline text-xs -ml-2 mb-4"
			[external]="true"
			[url]="lenderWebsiteLink"
			>Go to
			{{
				financialInstitution?.branch?.name ??
					financialInstitution?.shortName ??
					financialInstitution?.name
			}}
			website</app-anchor
		>
		<ng-container
			*ngIf="_mortgage?.forms?.financialInstitutionId; else noForms"
		>
			<div class="flex flex-col mb-4">
				<div *ngFor="let form of lenderForms">
					<app-anchor
						class="mt-3"
						type="pill"
						[url]="baseRoute + '/' + form.id + '/' + _mortgage?.id"
						>{{ PDFForms[form.documentName]?.name }}</app-anchor
					>
				</div>
			</div>
			<div class="flex justify-center">
				<app-button
					btn="primary"
					size="small"
					(click)="openLenderFormModal(_mortgage?.id)"
					[icon]="ICON.ADD"
					>Add lender forms</app-button
				>
			</div>
		</ng-container>
	</ng-container>
	<ng-template #noForms>
		<app-no-forms-available></app-no-forms-available>
	</ng-template>
	<ng-template #noFinancialInstitution>
		<a
			class="group hover:border-green-lighter transition-colors p-4 w-full rounded-xl border flex flex-row cursor-pointer items-center border-grey-lighter bg-white no-forms-background"
			(click)="goToMortgage()"
		>
			<app-icon class="text-grey-darker mr-2" [icon]="ICON.WARNING"></app-icon>
			<div class="flex flex-row flex-1 justify-between gap-2.5 items-center">
				<div class="flex flex-col gap-1">
					<p class="text-sm text-grey-darker font-bold">
						Looks like you haven't selected a lender.
					</p>
					<p class="text-xs text-grey-dark">Select a lender to continue.</p>
				</div>
				<div
					class="text-grey-darker flex flex-row gap-2 items-center lender-forms-bot"
				>
					<app-icon [icon]="ICON.ARROW_RIGHT"></app-icon>
				</div>
			</div>
		</a>
	</ng-template>
</app-container>
